var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar'),_c('main',{class:_vm.$style.container},[_vm._t("default")],2),_c('transition',{attrs:{"name":"fade"}},[(_vm.loggedIn && _vm.getUserCompleted && !_vm.introSurveyAnswered)?_c('IntroSurveyModalModal'):_vm._e()],1),_c('SessionExpiredModal',{attrs:{"user-session-expired":_vm.userSessionExpired}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }